import { render } from "./GenbaInfoModal.vue?vue&type=template&id=32feea9f&scoped=true"
import script from "./GenbaInfoModal.vue?vue&type=script&lang=js"
export * from "./GenbaInfoModal.vue?vue&type=script&lang=js"

import "./GenbaInfoModal.vue?vue&type=style&index=0&id=32feea9f&scoped=true&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32feea9f"]])

export default __exports__